import { GarageState } from "reducer/garage.reducer";
import { ISetGarageAction } from "../interfaces/garage.interface";

export default function setGarageState(garageState: GarageState): ISetGarageAction {
  return {
    type: "SET_GARAGE",
    data: garageState,
  };
}
